export default __webpack_public_path__ + "static/media/tun.28dd10f2.png";